<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('title.password')")

			.form-container.form-login
				.field(v-if="!restorePassword || !isTokenUser")
					p.control.has-icons-left
						input.input(type="password" :placeholder="$t('placeholder.password_current')" v-model="password")
						span.icon.is-small.is-left
							lock-icon(size="1.5x")

				.field
					p.control.has-icons-left
						input.input(type="password" :placeholder="$t('placeholder.password_new')" v-model="newPassword")
						span.icon.is-small.is-left
							lock-icon(size="1.5x")

				.field
					p.control.has-icons-left
						input.input(type="password" :placeholder="$t('placeholder.password_confirm_new')" v-model="passwordConfirm")
						span.icon.is-small.is-left
							lock-icon(size="1.5x")

				.field.margin-top-md
					p.control.has-text-centered
						button.button.is-primary(type="button" v-bind:class="buttonClass" @click="submitPassword")
							| {{ $t('button.submit') }}
							span.icon.feather
								chevron-right-icon

				article.message.is-success(v-if="successPassword" transition="fade")
					.message-body
						| {{ $t('alert.password_changed') }}

				article.message.is-danger(v-if="errorPassword" transition="fade")
					.message-body
						| {{ $t('alert.missing_password') }}
				article.message.is-danger(v-else-if="errorPasswordComplexity" transition="fade")
					.message-body
						| {{ $t('alert.missing_password_complexity') }}
				article.message.is-danger(v-else-if="errorNewPassword" transition="fade")
					.message-body
						| {{ $t('alert.missing_password_new') }}
				article.message.is-danger(v-else-if="errorPasswordConfirm" transition="fade")
					.message-body
						| {{ $t('alert.missing_password_confirm') }}
				article.message.is-danger(v-else-if="errorPasswordMismatch" transition="fade")
					.message-body
						| {{ $t('alert.missing_new_password_mismatch') }}
				article.message.is-danger(v-else-if="errorPasswordMatch" transition="fade")
					.message-body
						| {{ $t('alert.missing_new_old_password') }}
				article.message.is-danger(v-else-if="errorAuth" transition="fade")
					.message-body
						| {{ $t('alert.invalid_login') }}

</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import CodeMessagesComponent from '../components/CodeMessagesComponent.vue'
import { LockIcon, ChevronRightIcon } from 'vue-feather-icons'

export default {
	components: {
		TitleComp: TitleComponent,
		ChevronRightIcon,
		LockIcon
	},
	data() {
		return {
			emptyPage              : false,
			errorPage              : false,
			errorAuth              : false,
			errorPassword          : false,
			errorNewPassword       : false,
			errorPasswordComplexity: false,
			errorPasswordConfirm   : false,
			errorPasswordMismatch  : false,
			errorPasswordMatch     : false,
			successPassword        : false,
			password               : '',
			newPassword            : '',
			passwordConfirm        : ''
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		isTokenUser() {
			if (this.$store.state.auth.accessToken) {
				return this.$store.state.auth.tokenType === 'user'
			}
			return false
		},
		loading() {
			return this.$store.state.auth.loading
		},
		restorePassword() {
			return this.$store.state.user.userRestorePassword
		},
		buttonClass() {
			return { 'is-loading': this.loading }
		}
	},
	mounted() {
		//this.$meta().setOptions({ title: this.$t("title.company_codes") + ' | ' + this.$t("title.home") })
	},
	methods: {
		submitPassword() {
			this.errorPassword = false
			this.errorNewPassword = false
			this.errorPasswordMatch = false
			this.errorPasswordMismatch = false
			this.errorAuth = false
			this.successPassword = false

			if (!this.restorePassword || !this.isTokenUser) {
				if (!this.password) {
					this.errorPassword = true
					return
				}
			}

			if (!this.newPassword) {
				this.errorNewPassword = true
				return
			}

			if (!this.passwordConfirm) {
				this.errorPasswordConfirm = true
				return
			}

			if (this.passwordConfirm !== this.newPassword) {
				this.errorPasswordMismatch = true
				return
			}

			if (this.password === this.newPassword) {
				this.errorPasswordMatch = true
				return
			}

			if (this.newPassword.length < 8) {
				this.errorPasswordComplexity = true
				return
			}

			const passwordRex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
			if (!passwordRex.test(this.newPassword)) {
				this.errorPasswordComplexity = true
				return
			}

			this.$store.dispatch('auth/submitPassword', this.restorePassword && this.isTokenUser ? {
				'restore_password': true,
				'account_user'    : this.isTokenUser,
				'new_password'    : this.newPassword,
				'confirm_password': this.passwordConfirm
			} : {
				'account_user'    : this.isTokenUser,
				'password'        : this.password,
				'new_password'    : this.newPassword,
				'confirm_password': this.passwordConfirm
			})
				.then(response => {
					if (response) {
						console.log(response)

						this.password = ''
						this.newPassword = ''
						this.passwordConfirm = ''

						this.$store.commit('user/SET_AUTH_RESTORE_PASSWORD', false)
						this.$nextTick(() => {
							this.successPassword = true
						})
					}
				})
				.catch(err => {
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 401:
								this.errorAuth = true
								break
							case 403:
								this.errorAuth = true
								break
							case 500:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
		}
	},
	watch: {
		password() {
			this.errorPassword = false
			this.errorPasswordMatch = false
			this.errorAuth = false
			this.successPassword = false
		},
		newPassword() {
			this.errorNewPassword = false
			this.errorPasswordMatch = false
			this.errorPasswordMismatch = false
			this.errorPasswordComplexity = false
			this.errorAuth = false
			this.successPassword = false
		},
		passwordConfirm() {
			this.errorPasswordConfirm = false
			this.errorPasswordMismatch = false
			this.errorAuth = false
			this.successPassword = false
		}
	}
}
</script>
